export const motion = {
  interactive:
    "transition-all duration-150 ease-control motion-reduce:transition-none motion-reduce:transform-none",
  page: "motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-2 motion-safe:duration-200 motion-reduce:animate-none",
  card: "motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-1 motion-safe:duration-200 motion-reduce:animate-none",
  dialogOverlay:
    "motion-safe:animate-in motion-safe:fade-in motion-safe:duration-150 motion-reduce:animate-none",
  dialogContent:
    "motion-safe:animate-in motion-safe:fade-in motion-safe:zoom-in-95 motion-safe:slide-in-from-bottom-2 motion-safe:duration-150 motion-reduce:animate-none",
};
